import Vue from "vue";
const debug = process.env.NODE_ENV !== "production";

/*
  Registering global components:
  Searches for every .vue file inside the components directory and loads it.
*/
const requireComponent = require.context(
    "./components",
    true, //Don't search into subdirectories
    /\.vue$/,
);

requireComponent.keys().forEach((fileName) => {
    const component = requireComponent(fileName);
    if (
        (component.hasOwnProperty("default") &&
            !component.default.hasOwnProperty("name")) ||
        component.default.name === null
    ) {
        if (debug) {
            console.error(
                "Please provide a name for component " + component.__file,
            );
        }
    }

    Vue.component(component.default.name, component.default);
});
